import SecondaryFooter from "./SecondaryFooter";

export default function CheckoutFooter() {
  return <SecondaryFooter />;
}
